export default {
  // حالتونه
  "common.mode.auto": "خپله کارونه",
  "common.mode.economy": "اقتصادي حالت",
  "common.mode.exigency": "بحراني حالت",

  // وسایل
  "common.grid": "بریښنايي شبکه",
  "common.evChargers": "د بریښنايي موټرو چارجنگ سټیشنونه",
  "common.evCharger": "د بریښنايي موټرو چارجنگ سټیشن",
  "common.pv": "لمرې انرژی",
  "common.inverter": "اینورټر",
  "common.pcs": "اینورټر + بټرۍ",
  "common.terminal": "وسیله",
  "common.airc": "د هوا تنظیم",
  "common.engine": "انجن",
  "common.battery": "بټرۍ",
  "common.metter": "بریښنا میټر",
  "common.other": "نور",
  "common.power": "قدرت",
  "common.powerTotal": "ټول قدرت",
  "common.voltage": "ولټاژ",
  "common.electricity": "بریښنايي مقدار",
  "common.current": "جریان",
  "common.homeUsage": "د کور ټول بار",
  "common.battery.power": "د بټرۍ قدرت",

  // معلومات
  "common.noDataAvailable": "اوس مهال هیڅ معلومات نشته~",
  "common.tips": "لارښود",
  "common.reset": "بیا تنظیمول",
  "common.currencyUnit": "¥",
  "common.submiting": "لیږل کیږي، مهربانی وکړئ انتظار وکړئ...",
  "common.close": "تړل",
  "common.from": "څخه",
  "common.useIn": "په کې کارول کیږي",
  "common.energyPercent": "د انرژۍ جریان درصد",
  "common.dataFlow": "د معلوماتو جریان",
  "common.getDataIng": "معلومات ترلاسه کیږي، مهربانی وکړئ انتظار وکړئ...",
  "common.pageLoading": "پاڼه بار کیږي، مهربانی وکړئ انتظار وکړئ...",
  "common.reseting": "د پاڼې مینه بیا تنظیم کیږي، مهربانی وکړئ انتظار وکړئ...",
  "common.save": "خوندي کول",
  "common.onlyNumberTips": "یوازې شمیرې دننه کولی شئ",
  "common.offline": "آفلاین",
  "common.online": "آنلاین",
  "common.fault":"عیب",
  "common.charge": "چارجول",
  "common.discharge": "ڈسچارجول",
  "common.buy": "پیرل",
  "common.sell": "پلورل",
  "common.loadingInfo": "بار کیږي، مهربانی وکړئ انتظار وکړئ...",

  // 
  "common.moreFeatures": "نورې функции",
  "common.confirm": "تاییدول",
  "common.saveing": "خوندي کیږي، مهربانی وکړئ انتظار وکړئ...",
  "common.searchPlacholder": "د پلټنې کلیمي لغت دننه کړئ",
  "common.iSee": "ما په پوه شو",
  "common.pageErrorTips1": "افسوس! په پاڼه کې یو تېروتنه راغله~",
  "common.pageErrorTips2": "مهربانی وکړئ پاڼه تازه کړئ یا د پیرودونکو سره اړیکه ونیسئ~",
  "common.refresh": "تازه کول",
  "common.backToHome": "کورني پاڼې ته راستنیدل",
  "common.checkTips": "چک کیږي، مهربانی وکړئ انتظار وکړئ...",
  "common.back": "بیرته",
  "common.cancel": "ردول",
  "common.optional": "اختیاري",
  "common.required": "اړین",
  "common.status": "حالت",
  "common.statusNoDelete": "نه دی حذف شوی",
  "common.statusDelete": "حذف شوی",
  "common.submit": "سپارل",
  "common.disable": "غیرفعال کول",
  "common.enable": "فعال کول",
  "common.year": "کال",
  "common.month": "میاشت",
  "common.day": "ورځ",
  "common.version": "د نسخه شمیره:",
  "common.backHome": " کورني پاڼې ته راستنیدل",
  "common.backHomeSorry": " بخښنه وغواړئ، پاڼه ورک شوه",
  "common.requestTips1": "معلومات پروسس کیږي، بیا مه لیږئ",
  "common.requestTips2": "د سیسټم پیغام",
  "common.requestTips3": "د ننوتلو حالت ختم شوی، بیا ننوځئ",
  "common.requestTips4": "بیا ننوتل",
  "common.requestTips5": "ناسم سیشن، یا سیشن ختم شوی، بیا ننوځئ",
  "common.requestTips6": "سرور کې خطا راغی، لطفاً وروسته بیا هڅه وکړئ.",
  "common.requestTips7": "د سیسټم غوښتنې وخت تیر شو",
  "common.requestTips8": "د سیسټم انٹرفیس",
  "common.requestTips9": "تېروتنه",
  "common.iknow": "ما په پوه شو",
  "common.logoutSuccess": "بریالۍ وتل",
  
  // د نورو مالوماتو برخه
  "common.knowMore.title": "د نورو مالوماتو لپاره، د بی نینګ سره اړیکه ونیسئ",
  "common.knowMore.email": "ایمیل",
  "common.knowMore.phone": "تلیفون",
  "common.knowMore.wechat": "وی چټ",
  "common.knowMore.website": "اصلي ویب پاڼه",
  "common.knowMore.address": "پته",
  "common.knowMore.addressDetail": "د ګوانګډونګ ایالت، د ډونګګوان ښار، د هوانګجیانګ ښارګوټي، هوانګجینګکینګ، د چینګهې سړک 8 شمیره، 5 ودانۍ، 1205 او 1305 خونه",
  
  // د محلي اړیکې برخه
  "common.localConnection": "محلي اړیکه",
  "common.operateInApp": "مهربانی وکړئ په اپلیکیشن کې عمل وکړئ!",
  
  "common.enbleStaus": "د فعالولو حالت",
  "common.battery.status": "نه چارجېږي او نه ڈسچارجېږي",

  "account.forgetThePassword": "پټنومره هیرې کړې",
    "account.logInDirectly": "مستقیم د ننوتلو پاڼې ته ولاړ شه",
    "account.tips1": "بیا لیږل کیږي، مهربانی وکړئ انتظار وکړئ...",
    "account.tips2": "لومړی د کارونکي شرایط ولولئ او ومنئ!",
    "account.autoLogin": "اتومات ننوتل",
    "account.userLogin": "د کارونکي ننوتل",
    "account.registerTips": "لا حساب نشته؟ دلته کلیک کړئ ترڅو ثبت شئ",
    "account.userEmail": "د کارونکي نوم/ایمیل",
    "account.userEmailTips": "د کارونکي نوم/ایمیل دننه کړئ",
    "account.password": "پټنوم",
    "account.passwordTips": "پټنوم دننه کړئ",
    "account.submit": "سپارل",
    "account.submitTips": "سپارل کیږي، مهربانی وکړئ انتظار وکړئ...",
    "account.otherLoginTips": "یا بل د ننوتلو طریقه غوره کړئ",
    "account.userRegistration": "د کارونکي ثبت",
    "account.userName": "د کارونکي نوم",
    "account.userNameTips": "د کارونکي نوم دننه کړئ",
    "account.emailTips1": "د ایمیل پته دننه کړئ",
    "account.emailTips2": "د ایمیل پته ناسمه ده",
    "account.phone": "د تلیفون شمیره",
    "account.phoneTips1": "د تلیفون شمیره دننه کړئ",
    "account.phoneTips2": "د تلیفون شمیره ناسمه ده",
    "account.phoneTips3": "د تلیفون شمیره دننه کړئ",
    "account.passwordTips1": "د 6-30 توری پټنوم دننه کړئ",
    "account.passwordTips2": "د پټنوم بڼه ناسمه ده. پټنوم باید د انګلیسي حروفو، شمیرو، انډرلاین، هایفن او ډاٹونو څخه جوړ شوی وي، اوږدوالی 6-12 توري",
    "account.passwordTips3": "پټنومره برابري نه کوي، بیا چک کړئ!",
    "account.passwordTips4": "پټنوم دننه کړئ. پټنوم باید د انګلیسي حروفو، شمیرو، انډرلاین، هایفن او ډاٹونو څخه جوړ شوی وي",
    "account.passwordTips5": "پټنوم تایید کړئ",
    "account.passwordTips6": "د تایید پټنوم دننه کړئ",
    "account.passwordTips7": "پټنومره برابري نه کوي، بیا چک کړئ!",
    "account.passwordTips8": "د تایید پټنوم دننه کړئ",
    "account.passwordTips9": "مبارک شه! ثبتونه بریالي شو!",
    "account.passwordTips10": "ستاسو د کارونکي نوم دا دی:",
    "account.emailIs": "ایمیل دا دی:",
    "account.goToLoginPage": "s به په اتوماتيک توګه د ننوتلو پاڼې ته ولېږل شي",
    "account.goLogin": "ننوتل",
    "account.goRegister": "ثبتول",
    "account.loginSuccess": "ننوتل بریالي شو",
    "account.email": "ایمیل",
    "account.sologn": "ستاسو د انرژۍ حلونه په پاملرنې سره جوړ شوي",
    "account.pleaseAgree": "ما ولولئ او ومنل",
    "userAgreement.privacyPolicy": "د محرمیت تګلاره",

    "account.code": "د تایید کوډ",
    "account.codeTips": "د تایید کوډ دننه کړئ",
    "account.codeTips2": "د تایید کوډ ناسم دی",

    "account.inviteCodeTips": "مهرباني وکړئ د بلنې کوډ دننه کړئ",
    "account.inviteCodeHint": "د بلنې کوډ ترلاسه کولو لپاره مهرباني وکړئ د نصبولو کارمند یا عملیاتو او ساتنې پرسونل سره اړیکه ونیسئ",
    "account.modifyPasswordByAccount": "د حساب له لارې د پټنوم بدلول",
    "account.modifyPasswordByEmail": "د ایمیل له لارې د پټنوم بدلول",
    "account.getPasswordByAccount": "د حساب له لارې د پټنوم بیرته ترلاسه کول",
    "account.getPasswordByEmail": "د ایمیل له لارې د پټنوم بیرته ترلاسه کول",

    "account.sendEmailTips": "د تایید کوډ ایمیل ته لیږل شوی، خپل انبکس وګورئ",
    "account.name": "د حساب نوم",
    "account.newPassword": "نوی پټنوم",
    "account.confirmNewPassword": "نوی پټنوم تایید کړئ",
    "account.nameTips": "د حساب نوم دننه کړئ",
    "account.passwordModifySuccess": "د پټنوم بدلول بریالی شو",
    "account.emailCode": "د ایمیل تایید کوډ",
    "account.emailCodeTips": "د ایمیل تایید کوډ دننه کړئ",
    "account.emailCodeTips2": "د ایمیل تایید کوډ ناسم دی",
    "account.emailModifySuccess": "د پټنوم بدلول بریالی شو",
    "account.passworTips1": "ستاسو پټنوم په بریالیتوب سره بیا تنظیم شو!",
    "account.passwordTips11": "د تایید پټنوم دننه کړئ",
    "account.passwordTips12": "نوی پټنوم دننه کړئ",
    "account.nickname": "د کارونکي مستعار نوم",
    "account.modifyNickname": "د کارونکي مستعار نوم بدلول",
    "account.modifyNicknameSuccess": "د کارونکي مستعار نوم په بریالیتوب سره بدل شو!",
    "account.nicknameTips": "د کارونکي مستعار نوم دننه کړئ",
    "account.nicknameError": "د کارونکي مستعار نوم بدلول ناکام شو!",

    "account.login": "ننوتل",
    "account.quickRegister": "چټک ثبت",
    "account.sendCode": "د تایید کوډ لیږل",
    "account.sendTips": "s بیا لیږلی شی",
    "account.sendEmailIng": "ایمیل لیږل کیږي، مهربانی وکړئ انتظار وکړئ...",
    "account.emailNotEmpty": "د ایمیل پته خالی نه شي",
    "account.registerAccount": "حاثونه ثبت کړئ",
    "account.registerWelcome": "SusprSafe ته ښه راغلاست",
    "account.usernameLimit": "د کارونکي نوم باید د حرفې څخه پیل شي او یوازې حرفې، شمیرې او انډرلاین ولري، اوږدوالی 5-15 توري",

    "copyright.desc2": "د ویب پاڼې د ثبت معلومات: Yue ICP-bei 2021169764",

    "editUserInfo.editUserInformation": "د کارونکي معلومات ایډیټ کړئ",
    "editUserInfo.modifyUsername": "د کارونکي نوم بدلول",
    "editUserInfo.changePictures": "د پروفایل عکس بدلول",
    "editUserInfo.savePicturesSuccess": "د پروفایل عکس په بریالیتوب سره خوندي شو",
    "editUserInfo.saveError": "خوندي کول ناکام شول",
    "editUserInfo.pictureLimit":"عکس باید له 2MB څخه کم وي",
    "editUserInfo.uploadPicture":"د پروفایل عکس پورته کړئ",
    "editUserInfo.picturePreview": "مخکې کتنه",
    
    "editUserInfo.bindPhoneNumber": "د تلیفون شمیره نښلول",
    "editUserInfo.bindEmail": "ایمیل نښلول",
    "editUserInfo.changePassword": "پټنوم بدلول",

    "editUserInfo.notificationSettings": "د خبرتیا تنظیمات",
    "editUserInfo.editAccount": "د حساب معلومات ایډیټ کړئ",
    "editUserInfo.waitBingting": "نښلول کیږي، مهربانی وکړئ انتظار وکړئ...",
    "editUserInfo.collapse": "راټیټول",
    "editUserInfo.modifyBinding": "نښلونه بدلول",
    
    "editUserInfo.emailAddress": "د ایمیل پته",
    "editUserInfo.tips1": "د ایمیل نښلول بریالی شو",
    "editUserInfo.tips2": "خوندي کول ناکام شول",
    "editUserInfo.tips3": "د ایمیل تایید کوډ لیږل کیږي، مهربانی وکړئ انتظار وکړئ...",
    "editUserInfo.tips4": "د تایید کوډ ایمیل xxxx ته لیږل شوی، وګورئ",
    "editUserInfo.tips5": "د تایید کوډ لیږل ناکام شو!",
    "editUserInfo.tips6": "تلیفون شمیره له پخوا نښلول شوې",
    "editUserInfo.tips7": "ایمیل له پخوا نښلول شوی",
    "editUserInfo.emailTips1": "د ایمیل پته دننه کړئ",
    "editUserInfo.emailTips2": "د ایمیل پته ناسمه ده",
    "editUserInfo.emailTips3": "xxxxs بیا لیږلی شی",
    "editUserInfo.emailTips4": "د تایید کوډ لیږل",
    "editUserInfo.emailTips5": "د ایمیل تایید کوډ خالی نه شي",
    "editUserInfo.emailTips6": "د ایمیل تایید کوډ ناسم دی",
    "editUserInfo.emailCode": "د ایمیل تایید کوډ",
    "editUserInfo.save": "خوندي کول",

    "editUserInfo.phoneTips1": "د تلیفون شمیره نښلول بریالی شو",
    "editUserInfo.phoneTips2": "د SMS تایید کوډ لیږل کیږي، مهربانی وکړئ انتظار وکړئ...",
    "editUserInfo.phoneTips3": "د SMS تایید کوډ تلیفون xxxx ته لیږل شوی، وګورئ",
    "editUserInfo.phoneTips4": "د SMS تایید کوډ لیږل ناکام شو!",
    "editUserInfo.phoneTips5": "د تلیفون شمیره دننه کړئ",
    "editUserInfo.phoneTips6": "د تلیفون شمیره ناسمه ده",
    "editUserInfo.phoneTips7": "د SMS تایید کوډ لیږل",
    "editUserInfo.phoneTips8": "د SMS تایید کوډ",
    "editUserInfo.phoneTips9": "د تلیفون تایید کوډ خالی نه شي",
    "editUserInfo.phoneTips10": "د تلیفون تایید کوډ ناسم دی",
    "editUserInfo.phone": "د تلیفون شمیره",


    "editUserInfo.noticeTips1": "د خبرتیا تنظیمات ترلاسه کول ناکام شول!",
    "editUserInfo.noticeTips2": "د خبرتیا تنظیمات په بریالیتوب سره خوندي شول!",
    "editUserInfo.noticeTips3": "د بټرۍ د کمې کچې خبرتیا",
    "editUserInfo.noticeTips4": "د چارجینګ پای خبرتیا",
    "editUserInfo.errorNotification": "د تېروتنې خبرتیا",
    "editUserInfo.updateNotification": "د اپډیټ خبرتیا",
    "editUserInfo.monthlyStatisticsNotification": "د میاشتې احصائیې خبرتیا",
    "editUserInfo.notificationMethod": "د ترلاسه کولو طریقه",

    "editUserInfo.userNameTips1": "د کارونکي نوم په بریالیتوب سره خوندي شو",
    "editUserInfo.userNameTips2": "د کارونکي نوم خوندي کول ناکام شول",
    "editUserInfo.userNameTips3": "د کارونکي نوم دننه کړئ",
    "editUserInfo.userNameTips4": "د کارونکي نوم بڼه ناسمه ده. باید د شمیرو، انډرلاین او حروفو څخه جوړ شوی وي",
    "editUserInfo.userNameTips5": "د کارونکي نوم دننه کړئ",
    "editUserInfo.userNameTips6": "خوندي کیږي، مهربانی وکړئ انتظار وکړئ...",
    "editUserInfo.userName": "د کارونکي نوم",

    "editUserInfo.avatorTips": "د پروفایل عکس بدلولو لپاره کلیک وکړئ",
    "editUserInfo.verifyCodeTips1": "د ترلاسه شوي تایید کوډ دننه کړئ:",
    "editUserInfo.verifyCodeTips2": "د ستاسو د حساب د امنیت لپاره، د اصلي تلیفون شمیرې ته د تایید کوډ لیږلو لپاره د لاندې بټن کلیک وکړئ:",
    "editUserInfo.verifyCodeTips3": "د تایید کوډ لیږل",
    "editUserInfo.verifyCodeTips4": "اصلي تلیفون تایید شو، د نښلولو لپاره نوی تلیفون شمیره دننه کړئ",
    "editUserInfo.verifyCodeTips5": "د ستاسو د حساب د امنیت لپاره، د اصلي ایمیل ته د تایید کوډ لیږلو لپاره د لاندې بټن کلیک وکړئ:",
    "editUserInfo.verifyCodeTips6": "اصلي ایمیل تایید شو، نوی ایمیل دننه کړئ",
    "editUserInfo.verifyCodeTips7": "زوړ پټنوم",
    "editUserInfo.verifyCodeTips8": "لومړی ایمیل نښلول!",
    "editUserInfo.verifyCodeTips9": "د تایید کوډ ایمیل ته لیږل شوی، خپل انبکس وګورئ",
    "editUserInfo.verifyCodeTips10": ", به په اتوماتيک توګه د ننوتلو پاڼې ته ولېږل شي",

    "hems.notice.title": "د خبرتیا سرلیک", 
   "hems.notice.content": "د خبرتیا محتوا", 
   "hems.notice.operate": "عمل",
   "hems.notice.noRead": "ناخوړل شوی",
   "hems.notice.read": "خوړل شوی",
   "hems.notice.warning": "خبرتیا",
   "hems.notice.error": "تېروتنه",
   "hems.notice.success": "احصایه او تصفییه",
   "hems.notice.sys": "د سیسټم معلومات",
   "hems.notice.operateSuccess": "عمل بریالی شو",
   "hems.notice.operateTips": "د عمل لپاره توکي وټاکئ",

    // کورنی پاڼه
   "hems.home.selfuseRate": "د ځان کارونې کچه",
   "hems.home.percent": "سلنه",
   "hems.home.todayData": "نننی معلومات",
   "hems.home.todayPowerGeneration": "نننی بریښنا تولید",
   "hems.home.salesIncome": "د بریښنا پلور عاید",
   "hems.home.saved": "تاسو سپما کړې",
   "hems.home.reduce": "د کاربن پځاو کم شوی",
   "hems.home.tips1": "هیڅ معلومات نشته، تاسو لا xxxx نښلولی نه دی",
   "hems.home.criticalLoad": "حساس بار",
   "hems.home.keyVoltage": "حساس ولټاژ",
   "hems.home.householdLoad": "د کور بار",
   "hems.home.householdVoltage": "د کور ولټاژ",
   "hems.home.generalLoad": "عمومي بار",
   "hems.home.generalVoltage": "عمومي ولټاژ",
   "hems.home.batteryHealth": "د بټرۍ روغتیا",
   "hems.home.averageTemp": "منځنی تودوخه",
   "hems.home.gridLoad": "د شبکه بار",
   "hems.home.toggeleDataSource": "ښکاره شوي معلومات بدل شوي:",
   "hems.home.toggleTips": "آیا په رښتیا بدلول غواړئ؟",
   "hems.home.modeSending": "د حالت امر لیږل کیږي، مهربانی وکړئ انتظار وکړئ...",
   "hems.home.modeSuccess": "د حالت بدلولو امر په بریالیتوب سره لیږل شو!",
   "hems.home.isOnline": "آیا آنلاین دی",
   "hems.home.useStatus": "د کارونې حالت",
   "hems.home.workModeText": "اوسنی د کار حالت:",
   "hems.home.toggleDataSourceText": "ښکاره شوي معلومات بدل شوي:",
   "hems.ev.charge.status": "د چارج حالت",
   "hems.ev.charge.time": "د چارج وخت",
   "hems.ev.charge.count": "د ریښتیني وخت چارج مقدار",
   "hems.ev.charge.status.empty":"خالي",
   "hems.ev.charge.status.ing":"د کیبل سره چارجیږي",
   "hems.ev.charge.status.null":"کیبل نښلول شوی، نه چارجیږي",
   "hems.ev.charge.status.error":"عیب",
   "hems.hour":"ساعت",
   "hems.minue":"دقیقه",
   "hems.ev.chagre.number": "د چارجنگ سټیشن شمیره",

   // د کارونکي لارښود
   "hems.userGuide.selfUse": "ځان کارونه",
   "hems.userGuide.selfUseTips": "د لمریزې انرژۍ کارونه لومړیتوب لري، کمښت د شبکه څخه تکمیل کیږي",
   "hems.userGuide.economyMode": "اقتصادي حالت",
   "hems.userGuide.economyModeTips": "د بریښنا د نرخونو پر بنسټ انرژۍ کارونه اصلاح کوي",
   "hems.userGuide.emergencyMode": "بحراني حالت",
   "hems.userGuide.emergencyModeTips": "لومړی د حساس بار بریښنا تضمین کوي",

   // د ګراف پاڼه
   "hems.history.energyStatistics": "د انرژۍ احصایه",
   "hems.history.revenueStatistics": "د عاید احصایه",
   "hems.history.greenStatistics": "شین تاثیر",
   "hems.history.revenueTitle": "د بریښنا پلور ټول عاید",
   "hems.history.savingsTitle": "ټوله سپما",
   "hems.history.carbonTitle": "د کاربن ډای اکسایډ د خپریدو ټوله کمښت",
   "hems.history.day": "ورځ",
   "hems.history.month": "میاشت",
   "hems.history.year": "کال",
   "hems.history.beforeDay": "تیره ورځ",
   "hems.history.afterDay": "بلی ورځ",
   "hems.history.beforeMonth": "تیره میاشت",
   "hems.history.afterMonth": "بله میاشت",
   "hems.history.beforeYear": "تیره کال",
   "hems.history.afterYear": "بل کال",
   "hems.history.totalUse": "ټوله کارونه",
   "hems.history.fullScreen": "بشپړه سکرین",
   "hems.history.timeSelect": "د نیټې ټاکل",
   "sync.tips1": "د معلوماتو د سنکرونیزیشن امر په بریالیتوب سره لیږل شو!",
   "sync.tips2":"د معلوماتو سنکرونیزیشن روان دی، د زیاتو معلوماتو له امله نیم ساعت وخت نیسي، مهربانی وکړئ وروسته راشئ~",
   "sync.tips3": "د وسیلې د معلوماتو سنکرونیزیشن ورو کیدی شي. که معلومات ناسم ښکاره شي، کلیک وکړئ:",
   "sync.tips4": "معلومات سنکرونیز کړئ",

   "charge.info": "د چارجنگ سټیشن معلومات",
    "news.loading": "باریږي...",
    "news.noMore": "نور نشته",
    "hems.pv.power": "د لمریزې انرژۍ ذخیره",

  // د UEH خاص
  "ueh.sellPower": "پلورل شوې بریښنا مقدار",
  
  "menu.home": "کورنی پاڼه",
  "menu.history": "تاریخ",
  "menu.device": "وسایل",
  "menu.settings": "تنظیمات",
  "menu.messageCenter": "خبرتیاوې",
  "menu.help": "مرسته او ملاتړ",
  "menu.mine": "زما حساب",


  "mine.userSetting": "د کارونکي تنظیمات",
  "mine.terminalSetting": "د وسیلې اساسي تنظیمات",
  "mine.uploadCloud": "د معلوماتو د بیکاپ cloud",
  "mine.changeVersion": "تازه معلومات وګورئ",
  "mine.language": "ژبه بدلول",
  "mine.about": "په اړه",
  "mine.feedback": "بازخورد",
  "mine.logout": "وتل",
  "mine.logoutAccount": "حساب ړنګول",

  "mine.logoutAccountTips": "د [] نوملړ حساب ړنګول",
  "mine.logoutAccountTips1": "[] تړلی حساب ړنګول",
  "mine.logoutAccountCare": "د حساب د ړنګولو اړینې موضوع:",
  "mine.logoutAccountCare1": "1. حساب په خوندي حالت کې دی",
  "mine.logoutAccountCare1-1": "حاسبه اوس په عادي توګه کارول کیږي، د غلا، سرغړونه، غیرفعالولو هیڅ خطر نشته",
  "mine.logoutAccountCare2": "2. د حساب اجازې/تړون لغوه شوي",
  "mine.logoutAccountCare2-1": "حاسبه د دریمې ډلې خدماتو سره اجازې پای ته رسولي دي.",
  "mine.logoutAccountCare3": "3. حساب د ړنګولو وروسته بیرته ترلاسه نشي، ټول معلومات ړنګیږي",
  "mine.logoutAccountCare3-1": "د حساب د ړنګولو وروسته، ټول معلومات او تړلي تلیفون شمیرې/ایمیل پتې په تلپاتې توګه لیرې کیږي.",
  "mine.confirmLogout": "ړنګول تایید کړئ",
  "mine.logoutSuccess": "حساب ړنګ شو!",

  "mine.feedbackIssues": "ستونزې راپور کړئ",
  "mine.feedQuantity": "مقدار",
  "mine.feedAmount": "اعظمي 9 عکسونه، اعظمي 1MB/عکس",

  "mine.notice.fail": "د خبرتیا تنظیمات ترلاسه کول ناکام شول!",
  "mine.notice.saveSuccess": "د خبرتیا تنظیمات په بریالیتوب سره خوندي شول!",
  "mine.notice.saveFail": "خوندي کول ناکام شول!",
  "mine.notice.title": "د خبرتیا تنظیمات",
  "mine.notice.batteryLow": "د بټرۍ د کمې کچې خبرتیا",
  "mine.notice.chargingFinish": "د چارجینګ د پای خبرتیا",
  "mine.notice.error": "د تېروتنې خبرتیا",
  "mine.notice.update": "د اپډیټ خبرتیا",
  "mine.notice.monthly": "د میاشتې احصائیې خبرتیا",
  "mine.notice.receiveType": "د ترلاسه کولو طریقه",

  "mine.language.welcome": "SusprSafe ته ښه راغلاست",
  "mine.language.desc1": "د خپل سیمې پر بنسټ د ژبې نسخه وټاکئ",
  "mine.language.desc2": "تاسو کولی شئ دا هر وخت د اپلیکیشن تنظیماتو څخه بدل کړئ",

  "mine.userInfo.avatar":"عکس",
  "mine.userInfo.nickname":"مستعار نوم",
  "mine.userInfo.password":"پټنوم",
  "mine.userInfo.changePassword":"پټنوم بدلول",
  "mine.userInfo.setPassword":"پټنوم ټاکل",
  "mine.userInfo.phoneNumber":"د تلیفون شمیره",
  "mine.userInfo.bindPhone":"د تلیفون شمیره نښلول",
  "mine.userInfo.bindEmail":"ایمیل نښلول",
  "mine.loginExpired":"د ننوتلو وخت تیر شوی، بیا ننوځئ",
  "mine.userInfo.title":"د کارونکي معلومات",
  "mine.userInfo.bind":"نښلول",
  "mine.userInfo.modify": "بدلول",
  "mine.userInfo.modifyNickname":"مستعار نوم بدلول",
  "mine.userInfo.userNickname":"د کارونکي مستعار نوم",
  "mine.userInfo.selectPic":"د پورته کولو لپاره عکس وټاکئ",
  "mine.userInfo.saveSuccess":"په بریالیتوب سره خوندي شو",
  "mine.userInfo.uploadFail":"پورته کول ناکام شول",
  "mine.userInfo.avatarSaveSuccess":"عکس په بریالیتوب سره خوندي شو",
  "mine.userInfo.nameTips1":"مستعار نوم خالی نه شي",
  "mine.userInfo.nameTips2":"مستعار نوم دننه کړئ",

  "common.pleaseSelect": "مهربانی وکړئ ټاکئ",
  "question.commonQuestions": "په مکرر ډول پوښتل شوي پوښتنې",
  "account.toggleLanguage": "ژبه بدلول",
  "account.localConnection": "محلي اړیکه",
  "account.selectLanguage": "ژبه وټاکئ",
  "account.sendEmailToast": "د تایید کوډ ایمیل xxx ته لیږل شوی، خپل انبکس وګورئ",
  "account.emailError": "د ایمیل بڼه ناسمه ده",
  "account.sendEmailFail": "لیږل ناکام شول، بیا هڅه وکړئ",

  "common.submitting": "سپارل کیږي، مهربانی وکړئ انتظار وکړئ...",

  "device.page.noData": "هیڅ معلومات نشته، د دې پاڼې لیدلو لپاره اپلیکیشن ته اړتیا ده"
 
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};